import { isValidOrgEmail } from "./contactValidation";

export const MAX_ORG_INVITE_BATCH = 50;
export const INVALID_EMAIL_MESSAGE = "A valid email is required";

/** Split a pasted list on commas, semicolons, and whitespace; unique lowercase. */
export function parseInviteEmails(raw) {
  const text = Array.isArray(raw) ? raw.join("\n") : String(raw || "");
  const seen = new Set();
  const out = [];
  for (const part of text.split(/[,;\s]+/)) {
    const email = part.trim().toLowerCase();
    if (!email || seen.has(email)) continue;
    seen.add(email);
    out.push(email);
  }
  return out;
}

export function partitionInviteEmails(raw) {
  const parsed = parseInviteEmails(raw);
  const valid = [];
  const invalid = [];
  for (const email of parsed) {
    if (isValidOrgEmail(email)) valid.push(email);
    else invalid.push(email);
  }
  return { parsed, valid, invalid };
}
